module.exports = {
    saveSearchData: {
        saveSearchInstrText: 'Enter your mobile number to receive text alerts for your saved searches.',
        textModalDisclaimer: 'To make it easy, we send text alerts using an automatic dialing system. Of course, you don\'t have to sign up for these text alerts to receive Autotrader services.',
    },
    sycUrl: '/sell-car/',
};
